import { render, staticRenderFns } from "./NetworkStatsPage.vue?vue&type=template&id=a1a8a4bc&scoped=true"
import script from "./NetworkStatsPage.vue?vue&type=script&lang=js"
export * from "./NetworkStatsPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1a8a4bc",
  null
  
)

export default component.exports